<template>
    <div class="group MT20">
        <div class="page-group-title"><span>简介</span></div>		
		<el-row :gutter="20"  class="MT20">
		    <el-col :xs="24" :xl="16">
		        <el-form-item prop="serviceTemplateId">
					<span slot="label">购买须知: </span>
		            <el-checkbox-group v-model="formData.serviceTemplateId" size="medium" style="margin-top: -10px;">
		                <span v-for="items in templateList" :key="items.id" class="MR20">
		                    <el-checkbox :label="items.id.toString()">
		                        {{items.title}}
		                    </el-checkbox>
		                    <el-popover width="400">
		                        <div v-html="items.chineseContent"></div>
		                        <el-link slot="reference" type="info" :underline="false" style="vertical-align: baseline;"><span class="el-icon-question"></span></el-link>
		                    </el-popover>
		                </span>
		            </el-checkbox-group>
		        </el-form-item>
		    </el-col>
		    <el-col :xs="24" :xl="16">
		        <el-form-item prop="description" :rules="[{required: true, message: '请输入图文信息'}]" :show-message="formData.description ? false : true">
		            <span slot="label">商品简介: </span>
		           <tinymce v-model="formData.description" :height="500" :toolbar="toolbar" :menubar="false" v-if="reFresh"></tinymce>
		        </el-form-item>
		    </el-col>
		</el-row>
		
		
        <!-- <el-row :gutter="30" class="MT20">
            <el-col :xs="24" :xl="16">
                <el-form-item prop="description" :rules="[{required: true, message: '请输入图文信息'}]" :show-message="formData.description ? false : true">
                    <tinymce v-model="formData.description" :height="500" :toolbar="toolbar" :menubar="false" v-if="reFresh"></tinymce>
                </el-form-item>
            </el-col>
        </el-row> -->
    </div>
</template>

<script>
import Tinymce from '@/components/Tinymce'; 

export default {
    props:{
        formData: {
            type: Object,
            default: null
        }, 
        reFresh: {
            type:Boolean,
            default: false
        },
    },
    components:{Tinymce},
    data(){
        return{
            toolbar:['formatselect fontsizeselect | forecolor bold strikethrough | alignleft aligncenter alignright alignjustify | image media | preview fullscreen'],
			serviceTemplateId2:'',
			templateList:[]
					
        }
    },
	 created(){
	   this.serviceTemplate()
	},
	methods:{
		//获取服务模板列表
		serviceTemplate(){
		    this.$request({
		        url: "/service/template/list",
		        data: {
					businessType: 2,
					pageNo:1,
					pageSize:100
				},
		        method: "post",
		    })
		        .then((res) => {
		            const { state, result } = res.data;
		            if (state == 1) {
		                this.templateList = result.result;
		            }
		        })
		        .catch(() => {
		        })
		        .finally(() => {
		            
		        });
		},
	},
	
}
</script>